var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOceanProtection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Beach-Sun-Birds--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Beach Sun Birds Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.78a1 1 0 0 0 1 -1V1.6a1 1 0 1 0 -2 0v1.18a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.06 5.05a1 1 0 0 0 0.71 0.29 1 1 0 0 0 0.71 -0.29 1 1 0 0 0 0 -1.42l-0.84 -0.83a1 1 0 0 0 -1.41 1.41Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9.1h1.18a1 1 0 0 0 0 -2H1a1 1 0 0 0 0 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.06 11.15 -0.83 0.85a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l0.84 -0.83a1 1 0 1 0 -1.42 -1.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.42v1.18a1 1 0 1 0 2 0v-1.18a1 1 0 0 0 -2 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.58 11.15a1 1 0 0 0 0 1.42l0.84 0.83a1 1 0 0 0 0.71 0.3 1 1 0 0 0 0.7 -1.71l-0.83 -0.84a1 1 0 0 0 -1.42 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.82 8.1a1 1 0 0 0 1 1H14a1 1 0 0 0 0 -2h-1.18a1 1 0 0 0 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.29 5.34a1 1 0 0 0 0.71 -0.29l0.84 -0.84a1 1 0 0 0 -1.42 -1.41l-0.84 0.83a1 1 0 0 0 0 1.42 1 1 0 0 0 0.71 0.29Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.53a3.41 3.41 0 1 0 -3.41 -3.41 3.41 3.41 0 0 0 3.41 3.41Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.83 11.4a0.52 0.52 0 0 1 0.54 -0.2 0.84 0.84 0 0 1 0.66 0.65 1 1 0 0 0 1.94 0 0.84 0.84 0 0 1 0.66 -0.65 0.52 0.52 0 0 1 0.54 0.2 1 1 0 1 0 1.66 -1.11 2.48 2.48 0 0 0 -2.54 -1.06 2.85 2.85 0 0 0 -1 0.39 0.48 0.48 0 0 1 -0.54 0 2.92 2.92 0 0 0 -1 -0.39 2.48 2.48 0 0 0 -2.54 1.06 1 1 0 1 0 1.66 1.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.87 21.34c-1.63 0.22 -2.74 -1.5 -2.75 -1.51a1 1 0 0 0 -1.71 0 3.3 3.3 0 0 1 -2.68 1.52 2.74 2.74 0 0 1 -2.34 -1.44 1 1 0 0 0 -1.71 -0.16 4.23 4.23 0 0 1 -3 1.6A3.43 3.43 0 0 1 6 19.83a1 1 0 0 0 -1.64 -0.09s-1.51 1.87 -3.2 1.64a1 1 0 0 0 -1.16 0.86 1 1 0 0 0 0.86 1.13 5.07 5.07 0 0 0 0.55 0 5.48 5.48 0 0 0 3.32 -1.29 0.48 0.48 0 0 1 0.63 0 5.07 5.07 0 0 0 3.28 1.25 5.65 5.65 0 0 0 3.4 -1.2 0.5 0.5 0 0 1 0.63 0 4.48 4.48 0 0 0 3.05 1.17A5 5 0 0 0 19 22.19a0.5 0.5 0 0 1 0.64 0 4.52 4.52 0 0 0 3.54 1.13 1 1 0 0 0 -0.26 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOceanProtection);
export default ForwardRef;